/*
* Contains common functions used in multiple files
* Copyright © 2025 Siemens Healthineers. All rights reserved.
*/
function toFixedDecimal(value) {
    let num = Number(value);
    if (isNaN(num)) {
        return "0";
    }
    if (Math.abs(num) < 1e-2 || Math.abs(num) > 1e5) {
        return num.toExponential(2);
    }
    else {
        return num.toFixed(2);
    }
}
export { toFixedDecimal };
//# sourceMappingURL=utils.js.map